import style from './Banner.module.scss';
import classNames from 'classnames';

export interface BannerProps {
  icon?: any;
  text?: string;
  className?: string;
  imgClassName?: string;
}

const Banner = ({ icon, text, className, imgClassName }: BannerProps) => {
  return (
    <>
      <div className={classNames([className, style.banner])}>
        {icon && (
          <img
            className={classNames([style.banner__img, imgClassName])}
            src={icon}
          />
        )}
        {text && icon && <span className={style.banner__text}>{text}</span>}
        {text && !icon && <span className={style.text__only}>{text}</span>}
      </div>
    </>
  );
};

export default Banner;
